import { memo, useCallback, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import Actions from "./Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import SelectMultipleListItem, {
  MultipleListItem,
} from "@coworker/apprestructured/src/task-management/components/SelectMultipleListItem/SelectMultipleListItem";
import { FixaSwitch } from "@coworker/apprestructured/src/shared/wrappers/FixaSwitch/FixaSwitch";

const availableItems: MultipleListItem[] = [
  { label: "Item 1", value: "item1" },
  { label: "Item 2", value: "item2" },
  { label: "Item 3", value: "item3" },
  { label: "Item 4", value: "item4" },
  { label: "Item 5", value: "item5" },
  { label: "Item 6", value: "item6" },
];

function SelectMultipleItemDemo() {
  const [selectedItems, setSelectedItems] = useState<MultipleListItem[]>([]);
  const [title, setTitle] = useState<string>("Select items");
  const [maxItems, setMaxItems] = useState<number>(3);
  const [label, setLabel] = useState<string>(`Select ${maxItems} items`);
  const [search, setSearch] = useState<boolean>(true);

  const handleConfirmClick = useCallback((newItems: MultipleListItem[]) => {
    setSelectedItems(newItems);
  }, []);

  return (
    <Demo>
      <Name>SelectMultipleListItem</Name>
      <Highlight>
        <FixaListView id="SelectMultipleItem" size="small">
          <SelectMultipleListItem
            title={title}
            selectedItems={selectedItems}
            items={availableItems}
            onConfirmClick={handleConfirmClick}
            maxItems={maxItems > 0 ? maxItems : undefined}
            search={search}
            label={label}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaInputField
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          type="text"
          label="title"
        />
        <FixaInputField
          id="label"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          type="text"
          label="Label"
        />
        <FixaInputField
          id="maxItems"
          value={String(maxItems)}
          onChange={(e) => setMaxItems(Number(e.target.value))}
          type="number"
          label="maxItems"
        />
        <FixaSwitch
          id="search"
          checked={search}
          onChange={() => setSearch(!search)}
          label="search"
          value=""
        />
      </Actions>
    </Demo>
  );
}

export default memo(SelectMultipleItemDemo);
